<template>
  <div class="fill-height">
    <main-toolbar>
      <v-toolbar-title>Graphs</v-toolbar-title>
      <DataParamsPicker
        slot="extension"
        v-model="dataParams"
        @input="update"
      >
      </DataParamsPicker>
    </main-toolbar>
    <GraphChart
      :params="dataParams"
    />
  </div>
</template>

<script>
import DataParamsPicker from '@/components/DataParamsPicker'
import DataParamsMixin from '@/mixins/DataParamsMixin'
import GraphChart from './GraphChart'
import get from 'lodash/get'

export default {
  mixins: [DataParamsMixin],
  components: {
    DataParamsPicker,
    GraphChart
  },
  data () {
    return {
      loading: false,
      dataParams: {}
    }
  },
  computed: {
    hasRequiredParams () {
      if (this.dataParams && this.dataParams.testType && this.dataParams.machine && (this.dataParams.last10 || (get(this.dataParams, 'dateRange.start') && get(this.dataParams, 'dateRange.start')))) {
        return true
      }
      return false
    }
  },
  watch: {
    $route () {
      // Update the testType anytime the query string changes it
      if (this.$route.query && Object.keys(this.$route.query).includes('testType')) {
        if (this.dataParams.testType !== this.$route.query.testType) {
          this.dataParams = {
            ...(this.dataParams || {}),
            testType: this.$route.query.testType
          }
        }
      }
    }
  },
  methods: {
    async update () {
      this.saveDataParams()
    }
  },
  mounted () {
    this.loadDataParams()
    this.dataParams.dateRange = this.dataParams.dateRange || {}
    this.dataParams.dateRange.start = this.$route.query.fromDate || this.dataParams.dateRange.start
    this.dataParams.dateRange.end = this.$route.query.toDate || this.dataParams.dateRange.end
    if (this.$route.query.range) {
      this.dataParams.dateRange = {
        range: this.$route.query.range,
        start: null,
        end: null
      }
    }
    if (this.$route.query.machine) {
      this.dataParams.machine = this.$route.query.machine
    }
    if (this.$route.query.testType) {
      this.dataParams.testType = this.$route.query.testType
    }
    document.getElementsByTagName('body')[0].classList.add('content-full-height')
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('content-full-height')
  }
}
</script>
